import React from 'react'
import '../css/main_style.css';
import '../css/index.css';
import MenuBar from '../pages/Menu'
import Toppart from '../pages/toppart'
import AppDone from '../pages/applicationdone'
import Footer from '../pages/Footer'

export default function Members() {
	return(		
		<div id="maincontainer">	
			<Toppart />
			<MenuBar />
			<AppDone />
			<Footer />	
		</div>	
	)
}
		